export const getClubScore = (score: number): string => {
  const units = [
    { threshold: 1000000, unit: "M", divider: 1000000 },
    { threshold: 1000, unit: "K", divider: 1000 },
    { threshold: 0, unit: "", divider: 1 },
  ];

  const { unit, divider } = units.find(({ threshold }) => score >= threshold)!;
  if (!unit) return score.toString();

  const value = score / divider;
  if (Number.isInteger(value)) return `${value}${unit}`;

  const formatted = value.toFixed(2);
  return formatted.endsWith("0")
    ? `${value.toFixed(1)}${unit}`
    : `${formatted}${unit}`;
};

export const rankCriteria: {
  [key: string]: { min: number; max?: number; rank: string }[];
} = {
  "총 핸드": [
    { min: 500000, rank: "DIAMOND" },
    { min: 100000, max: 499999, rank: "PLATINUM" },
    { min: 50000, max: 99999, rank: "GOLD" },
    { min: 10000, max: 49999, rank: "SILVER" },
    { min: 0, max: 9999, rank: "BRONZE" },
  ],
  "베팅 GP": [
    { min: 500000000, rank: "DIAMOND" },
    { min: 100000000, max: 499999999, rank: "PLATINUM" },
    { min: 50000000, max: 99999999, rank: "GOLD" },
    { min: 10000000, max: 49999999, rank: "SILVER" },
    { min: 0, max: 9999999, rank: "BRONZE" },
  ],
  "총 승리": [
    { min: 50000, rank: "DIAMOND" },
    { min: 10000, max: 49999, rank: "PLATINUM" },
    { min: 5000, max: 9999, rank: "GOLD" },
    { min: 1000, max: 4999, rank: "SILVER" },
    { min: 0, max: 999, rank: "BRONZE" },
  ],
  "토너먼트 참여": [
    { min: 500, rank: "DIAMOND" },
    { min: 100, max: 499, rank: "PLATINUM" },
    { min: 50, max: 99, rank: "GOLD" },
    { min: 10, max: 49, rank: "SILVER" },
    { min: 0, max: 9, rank: "BRONZE" },
  ],
  "토너먼트 Trophy": [
    { min: 100, rank: "DIAMOND" },
    { min: 50, max: 99, rank: "PLATINUM" },
    { min: 10, max: 49, rank: "GOLD" },
    { min: 1, max: 9, rank: "SILVER" },
    { min: 0, max: 0, rank: "BRONZE" },
  ],
  레이크: [
    { min: 50000000, rank: "DIAMOND" },
    { min: 10000000, max: 49999999, rank: "PLATINUM" },
    { min: 5000000, max: 9999999, rank: "GOLD" },
    { min: 1000000, max: 4999999, rank: "SILVER" },
    { min: 0, max: 999999, rank: "BRONZE" },
  ],
};

export const getRank = (score: number, type: string, top?: number): string => {
  const criteria = rankCriteria[type] || rankCriteria["총 핸드"];
  const tier = criteria.find(({ min }) => score >= min)!.rank;
  if (top && top <= 3 && tier === "DIAMOND") {
    return "MASTER";
  }
  return tier;
};

export const getNextRank = (current: number, type: string) => {
  const criteria = rankCriteria[type] || rankCriteria["총 핸드"];
  const currentRank = criteria.find(({ min }) => current >= min)!;
  if (currentRank.max === undefined) return 0;
  return currentRank.max - current + 1;
};

export const getBarWidth = (current: number, type: string) => {
  const criteria = rankCriteria[type] || rankCriteria["총 핸드"];
  const currentRank = criteria.find(({ min }) => current >= min)!;
  if (currentRank.max === undefined) return 100;

  const width =
    ((current - currentRank.min) / (currentRank.max - currentRank.min)) * 100;
  return Math.max(0, Math.min(100, width));
};
